import { GatsbyImage } from "gatsby-plugin-image";
import { ImageProps } from "./types";
import BaseImage, { convertBaseImageProps } from "./BaseImage";
import React from "react";

const Image = (props: ImageProps) => {
  const {
    alt,
    customClass,
    gatsbyImage,
    loadingType = "lazy",
    featchPriority = "auto",
    objectFit = "cover",
  } = props;

  if (gatsbyImage) {
    return (
      <GatsbyImage
        fetchpriority={featchPriority}
        alt={alt}
        loading={loadingType}
        className={customClass}
        image={gatsbyImage}
        objectFit={objectFit}
      />
    );
  }

  return <BaseImage {...convertBaseImageProps(props)} />;
};

export default Image;
